
import { Helper } from '../../helpers/Helper';

/**
 * ScrollBlob Class
 * --scroll property is needed for blob animation which not supports animation-timeline: scroll()
 * (Firefox and Safari)
 */
export class ScrollBlob {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( ! this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}

		this.init();

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init() {

		if ( this.allBlocks.length > 0 ) {

			this.allBlocks.forEach( ( block, index ) => {

				if( index >0 ) {


					Helper.removeClassFromEl( block, 'has-blob' );
					block.remove();

				}

			} );

		}


		window.addEventListener( 'scroll', () => {


			document.body.style.setProperty( '--scroll', window.scrollY / ( document.body.offsetHeight - window.innerHeight ) );

		}, false );

	}

}
